export default __webpack_public_path__ + "static/media/PreFooter.cc240aa9.svg";